import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteContact } from '../../api/siteContact';

const EMPTY = {
  publicEmail: '',
  phone: '',
  whatsapp: '',
  address: '',
  location: '',
  instagram: '',
  facebook: '',
};

const Footer = () => {
  const year = new Date().getFullYear();
  const { data } = useSiteContact();
  const contact = { ...EMPTY, ...(data || {}) };

  return (
    <footer className="bg-paper-soft mt-32">
      <div className="rule-strong" />
      <div className="max-w-editorial mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <p className="font-display text-3xl leading-none">
              Shubh<span className="text-saffron">Jyotish</span>
            </p>
            <p className="eyebrow mt-3">Vedic Astrology &middot; Numerology</p>
            <p className="font-serif text-ink-soft mt-6 max-w-sm leading-relaxed">
              A practice rooted in classical study and personal counsel. Readings
              are private, considered, and conducted in the tradition of careful
              correspondence.
            </p>
          </div>

          {/* Navigate */}
          <div className="md:col-span-3">
            <p className="eyebrow mb-5">Pages</p>
            <ul className="space-y-3 font-serif text-ink">
              <li><Link to="/" className="link-underline">Home</Link></li>
              <li><Link to="/about" className="link-underline">About the Astrologer</Link></li>
              <li><Link to="/services" className="link-underline">Services</Link></li>
              <li><Link to="/blog" className="link-underline">Blog</Link></li>
              <li><Link to="/contact" className="link-underline">Correspondence</Link></li>
            </ul>
          </div>

          {/* Correspondence */}
          <div className="md:col-span-4">
            <p className="eyebrow mb-5">By Post &amp; Wire</p>
            <dl className="space-y-4 font-serif text-ink">
              {contact.publicEmail && (
                <div>
                  <dt className="eyebrow text-ink-faint mb-1">Mail</dt>
                  <dd>
                    <a href={`mailto:${contact.publicEmail}`} className="link-underline">
                      {contact.publicEmail}
                    </a>
                  </dd>
                </div>
              )}
              {contact.phone && (
                <div>
                  <dt className="eyebrow text-ink-faint mb-1">Telephone</dt>
                  <dd className="font-mono text-sm tracking-wide">{contact.phone}</dd>
                </div>
              )}
              {contact.location && (
                <div>
                  <dt className="eyebrow text-ink-faint mb-1">Studio</dt>
                  <dd>{contact.location}</dd>
                </div>
              )}
            </dl>
          </div>
        </div>

        <div className="rule mt-16" />
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mt-6">
          <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-ink-muted">
            &copy; {year} ShubhJyotish &middot; All rights reserved
          </p>
          <div className="flex gap-6 font-mono text-[11px] tracking-[0.18em] uppercase text-ink-faint">
            {contact.whatsapp && (
              <a
                href={`https://wa.me/${contact.whatsapp.replace(/\D/g, '')}`}
                target="_blank"
                rel="noreferrer"
                className="link-underline"
              >
                WhatsApp
              </a>
            )}
            {contact.instagram && (
              <a
                href={contact.instagram}
                target="_blank"
                rel="noreferrer"
                className="link-underline"
              >
                Instagram
              </a>
            )}
            {contact.facebook && (
              <a
                href={contact.facebook}
                target="_blank"
                rel="noreferrer"
                className="link-underline"
              >
                Facebook
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
